import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=395f240e&scoped=true&"
import script from "./table-body.vue?vue&type=script&lang=ts&"
export * from "./table-body.vue?vue&type=script&lang=ts&"
import style0 from "./table-body.vue?vue&type=style&index=0&id=395f240e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f240e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCombobox,VIcon,VTextField,VTooltip})
